var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 19.9998L20.2527 15.9998L13.3327 11.9998V19.9998ZM28.746 9.55984C28.9193 10.1865 29.0394 11.0265 29.1194 12.0932C29.2127 13.1598 29.2527 14.0798 29.2527 14.8798L29.3327 15.9998C29.3327 18.9198 29.1193 21.0665 28.746 22.4398C28.4127 23.6398 27.6393 24.4132 26.4394 24.7465C25.8127 24.9198 24.666 25.0398 22.906 25.1198C21.1727 25.2132 19.586 25.2532 18.1193 25.2532L15.9993 25.3332C10.4127 25.3332 6.93268 25.1198 5.55935 24.7465C4.35935 24.4132 3.58602 23.6398 3.25268 22.4398C3.07935 21.8132 2.95935 20.9732 2.87935 19.9065C2.78602 18.8398 2.74602 17.9198 2.74602 17.1198L2.66602 15.9998C2.66602 13.0798 2.87935 10.9332 3.25268 9.55984C3.58602 8.35984 4.35935 7.5865 5.55935 7.25317C6.18602 7.07984 7.33268 6.95984 9.09268 6.87984C10.826 6.7865 12.4127 6.7465 13.8793 6.7465L15.9993 6.6665C21.586 6.6665 25.066 6.87984 26.4394 7.25317C27.6393 7.5865 28.4127 8.35984 28.746 9.55984Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.ca5c6a65fdbe27b93a5cf9fbef48ee8a.svg";
export { ForwardRef as ReactComponent };